import React, { useCallback, useState, useMemo } from 'react'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import { useHistory } from 'react-router'

const Login = () => {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState('')

	const history = useHistory()

	const handleSignInPress = useCallback(
		async () => {
			const userAuth = await firebase.auth().signInWithEmailAndPassword(email, password)

			if (!userAuth.user) {
				setError('Invalid email/password combination')
				setPassword('')
				return
			}

			const user = await firebase.firestore().doc(`/users/${userAuth.user.uid}`).get()

			if (!user || !user.exists || !user.data()) {
				setError('Invalid email/password combination')
				setPassword('')
				await firebase.auth().signOut()
				return
			}

			const userData = user.data()

			if (!(userData?.isAdmin)) { // 1jF53N9Ikc2T
				setError('Invalid email/password combination')
				setPassword('')
				await firebase.auth().signOut()
				return
			}

			setError('')
			history.push('/transactions')
		},
		[email, history, password],
	)

	const isValid = useMemo(
		() => {
			return email.trim() !== ''
				&& password.trim() !== ''
		},
		[email, password],
	)

	return (
		<div className="container flex flex-col h-screen mx-auto items-center pt-12">
			<img src="/img/logo.png" className="h-20" alt="" />
			<div className="bg-white w-full sm:max-w-md shadow rounded p-4 mt-12">
				<h1 className="text-lg font-bold">Sign in to your account</h1>
				<div className="flex flex-col w-full mt-4">
					<input type="text" name="email" onChange={(e) => { setEmail(e.target.value) }} placeholder="Email address" />
					<input type="password" name="password" onChange={(e) => { setPassword(e.target.value) }} placeholder="Password" />
					<p className="text-center mt-2 text-sm text-red-600">
						{error}
					</p>
					<button disabled={!isValid} onClick={handleSignInPress} className="mt-4 self-end">
						Sign in
					</button>
				</div>
			</div>
		</div>
	)
}

export default Login
